import { removeCookies } from "../cookie";
import dispatchUlmProfileEvent from "./dispatchUlmProfileEvent";
import psl from "./psl";
export default function logout() {
    var domain = "." + (psl(window.location.hostname) || window.location.hostname);
    removeCookies([
        { name: "acm_ulm_access_token", domain: domain },
        { name: "acm_ulm_refresh_token", domain: domain },
        { name: "acm_ulm_payload", domain: domain },
        { name: "acm_ulm_uuid", domain: domain },
        { name: "AstroUlmEPUID", domain: domain },
    ]);
    dispatchUlmProfileEvent();
}
